export default __webpack_public_path__ + "static/media/selected.449bf2c0.svg";